
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dOOm2", function(module, exports) {

$parcel$export(module.exports, "AIBorder", () => $f64c374ed616824e$export$6ed1e39f4dbe0bbf);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $7hpmn = parcelRequire("7hpmn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64c374ed616824e$var$GradientPropertyContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1osq _kqswh2mm _c71l1kw7",
            __cmplp.className
        ])
    });
});
const $f64c374ed616824e$var$outerContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $7hpmn.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f64c374ed616824e$var$animationStyles = (0, $ecnYn.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f64c374ed616824e$var$baseGlowStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f64c374ed616824e$var$defaultBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius.200'
});
const $f64c374ed616824e$var$modalBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius.100'
});
const $f64c374ed616824e$var$innerContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f64c374ed616824e$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f64c374ed616824e$var$outerContainerStyles,
        $f64c374ed616824e$var$animationStyles
    ] : [
        $f64c374ed616824e$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f64c374ed616824e$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f64c374ed616824e$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f64c374ed616824e$var$modalBorderRadiusStyles : $f64c374ed616824e$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($f64c374ed616824e$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props,
        children: [
            shouldRotate && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: [
                    ...containerStyles,
                    borderRadiusStyles,
                    ...hideGlow ? [] : glowStyles
                ],
                testId: "loading-glow"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: [
                    ...containerStyles,
                    borderRadiusStyles
                ],
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    padding: "space.025",
                    xcss: [
                        $f64c374ed616824e$var$innerContainerStyles,
                        borderRadiusStyles,
                        customInnerContainerStyles
                    ],
                    children: children
                })
            })
        ]
    });
};

});

parcelRegister("8LJEA", function(module, exports) {

$parcel$export(module.exports, "AISummaryLoading", () => $c33e9757ca53561f$export$dd8c26521b6a2fec);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $igbBp = parcelRequire("igbBp");
const $c33e9757ca53561f$var$BoxStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    backgroundColor: 'elevation.surface.sunken',
    padding: 'space.150',
    borderRadius: '8px',
    borderBottomLeftRadius: '3px'
});
const $c33e9757ca53561f$var$i18n = (0, $2nPZH.defineMessages)({
    generatingSummaryText: {
        id: "ai-summary-loading.title",
        defaultMessage: "Writing a summary"
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $c33e9757ca53561f$export$dd8c26521b6a2fec = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $c33e9757ca53561f$var$BoxStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$c33e9757ca53561f$var$i18n.generatingSummaryText
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($c33e9757ca53561f$var$i18n.generatingSummaryAnimationAlt)
                })
            ]
        })
    });
};

});

parcelRegister("fooTI", function(module, exports) {

$parcel$export(module.exports, "AITelepointerWrapper", () => $3ef04317b5e4f55f$export$e372ffc7075fd6f3);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $3ef04317b5e4f55f$var$telepointerStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    position: 'absolute',
    width: '1.5px',
    height: '25px',
    background: 'linear-gradient(45deg, #F8E6A0 -12.02%, #8BDBE5 19.18%, #0C66E4 71.87%)',
    marginLeft: 'space.025',
    marginTop: 'space.negative.100',
    '::after': {
        content: '"AI"',
        position: 'absolute',
        display: 'block',
        top: 'space.0',
        left: 'space.0',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '10px',
        fontWeight: 'font.weight.bold',
        width: '12.5px',
        height: '13px',
        paddingTop: 'space.025',
        paddingLeft: 'space.025',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'initial',
        borderRadius: '0px 2px 2px 0px',
        color: 'color.text.inverse',
        background: 'linear-gradient(45deg, #8BDBE5 -57%, #0C66E4 71.87%)'
    }
});
const $3ef04317b5e4f55f$var$isAValidContainer = (node)=>{
    if (node.hasChildNodes() && node.lastChild?.nodeType !== Node.TEXT_NODE) return true;
    return false;
};
const $3ef04317b5e4f55f$var$getNestedLastChild = (originNode)=>{
    if ($3ef04317b5e4f55f$var$isAValidContainer(originNode) && originNode.lastChild) return $3ef04317b5e4f55f$var$getNestedLastChild(originNode.lastChild);
    else if (originNode.textContent === '' && originNode.parentNode) return originNode.parentNode;
    else return originNode;
};
const $3ef04317b5e4f55f$export$e372ffc7075fd6f3 = ({ hideTelepointer: hideTelepointer = false, children: children })=>{
    const containerRef = (0, $gwFzn.useRef)(null);
    const telepointerRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        if (!hideTelepointer) {
            const renderer = containerRef.current;
            if (renderer.lastChild && telepointerRef.current) $3ef04317b5e4f55f$var$getNestedLastChild(renderer.lastChild).appendChild(telepointerRef.current);
        }
    }, [
        children,
        hideTelepointer
    ]);
    if (hideTelepointer) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                as: "span",
                ref: telepointerRef,
                xcss: $3ef04317b5e4f55f$var$telepointerStyles,
                testId: "ai-telepointer-cursor"
            }),
            children
        ]
    });
};

});

parcelRegister("63blV", function(module, exports) {

$parcel$export(module.exports, "AIAttributionFooter", () => $75f4c452dbf67a05$export$c7fc4bd65402b494);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $3Mg7y = parcelRequire("3Mg7y");

var $4vzBZ = parcelRequire("4vzBZ");

var $5nBzc = parcelRequire("5nBzc");

var $fpGTa = parcelRequire("fpGTa");
var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $4JDbp = parcelRequire("4JDbp");

var $ezYWs = parcelRequire("ezYWs");

var $jjneR = parcelRequire("jjneR");
const $75f4c452dbf67a05$var$footerContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $75f4c452dbf67a05$var$footerDisclaimerStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.050'
});
const $75f4c452dbf67a05$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    textDecoration: 'none',
    ':hover': {
        color: 'color.text.selected',
        cursor: 'pointer',
        textDecoration: 'underline'
    }
});
const $75f4c452dbf67a05$export$c7fc4bd65402b494 = ({ onLinkClick: onLinkClick, showBetaLozenge: showBetaLozenge })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [footerWidth, setFooterWidth] = (0, $gwFzn.useState)(0);
    const betaLozengeText = formatMessage((0, $jjneR.i18n).betaLozenge);
    const attributionMessage = ()=>{
        if (footerWidth >= (0, $ezYWs.LARGE_BREAKPOINT)) return formatMessage((0, $jjneR.i18n).attributionFooterAttributionLabelLarge);
        else if (footerWidth >= (0, $ezYWs.MEDIUM_BREAKPOINT) && footerWidth < (0, $ezYWs.LARGE_BREAKPOINT)) return formatMessage((0, $jjneR.i18n).attributionFooterAttributionLabelMedium);
        else return null;
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $75f4c452dbf67a05$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setFooterWidth
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                alignBlock: "center",
                xcss: $75f4c452dbf67a05$var$footerDisclaimerStyles,
                space: "space.050",
                children: [
                    showBetaLozenge && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
                        children: betaLozengeText
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #626F86)",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fpGTa.default), {
                        xcss: $75f4c452dbf67a05$var$linkStyles,
                        href: (0, $ezYWs.LINK_HREF),
                        target: "_blank",
                        onClick: onLinkClick,
                        children: footerWidth >= (0, $ezYWs.LARGE_BREAKPOINT) ? formatMessage((0, $jjneR.i18n).attributionFooterDisclaimerLarge) : formatMessage((0, $jjneR.i18n).attributionFooterDisclaimer)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                space: "space.075",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: attributionMessage()
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                        color: "var(--ds-icon, #44546F)",
                        label: formatMessage((0, $jjneR.i18n).atlassianIntelligenceIconAlt)
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("ezYWs", function(module, exports) {

$parcel$export(module.exports, "LARGE_BREAKPOINT", () => $010c748f3ca601da$export$ba58b4d4ecb9b338);
$parcel$export(module.exports, "MEDIUM_BREAKPOINT", () => $010c748f3ca601da$export$3a75af9c02826b93);
$parcel$export(module.exports, "LINK_HREF", () => $010c748f3ca601da$export$e2297811c4a04978);
const $010c748f3ca601da$export$ba58b4d4ecb9b338 = 600;
const $010c748f3ca601da$export$3a75af9c02826b93 = 320;
const $010c748f3ca601da$export$e2297811c4a04978 = 'https://www.atlassian.com/trust/atlassian-intelligence';

});

parcelRegister("jjneR", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $d509bd528a228fac$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $d509bd528a228fac$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    attributionFooterDisclaimerLarge: {
        id: "attribution-footer.disclaimer.large.text",
        defaultMessage: "Content is based on your permissions and its quality may vary"
    },
    attributionFooterDisclaimer: {
        id: "attribution-footer.disclaimer.text",
        defaultMessage: "Content quality may vary"
    },
    attributionFooterAttributionLabelLarge: {
        id: "attribution-footer.attribution-label.large.text",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    attributionFooterAttributionLabelMedium: {
        id: "attribution-footer.attribution-label.medium.text",
        defaultMessage: "Powered by AI"
    },
    atlassianIntelligenceIconAlt: {
        id: "attribution-footer.atlassian-intelligence-icon.alt-text",
        defaultMessage: "Atlassian Intelligence"
    },
    betaLozenge: {
        id: "attribution-footer.beta-lozenge",
        defaultMessage: "Beta"
    }
});

});



//# sourceMappingURL=ObjectSidebarControl.0564abe1.js.map
